import { Avatar, AvatarFallback, AvatarImage } from "@radix-ui/react-avatar";

import { Badge } from "@/components/Badge";
import Icon from "@/components/Icon/Icon";
import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { TextVariant } from "@/components/Typography/Text.variant";
import { defaultNS } from "@/lib/i18n";
import { useTranslation } from "@/lib/i18n";
import { SoftwareTypeEnum } from "@/routes/_staff/software/-const";

import type { SoftwareDetailRes } from "../_$id/-query/type";

import SoftwareStatusSummary from "./SoftwareStatusSummary";

interface SoftwareHeaderProps {
  software: SoftwareDetailRes;
}

export default function SoftwareHeader({ software }: SoftwareHeaderProps) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.software.detail",
  });

  return (
    <HStack className="gap-4">
      <VStack className="gap-2">
        <Text variant={TextVariant.h2}>{software.info.name}</Text>
        <HStack className="gap-2 items-center">
          {/* Custom SaaSバッジ表示 */}
          {software.info.type === SoftwareTypeEnum.CUSTOM_SAAS && (
            <Badge variant="secondaryMuted" className="text-xs">
              {t("customSaasBadge")}
            </Badge>
          )}

          <Avatar className="flex h-[16px] w-[16px]">
            <AvatarImage
              src={software.info.logo}
              alt={software.vendor.name || "ベンダー"}
              onError={(e) => {
                console.error("Image load error:", e);
              }}
              onLoad={() => {
                console.log("Image loaded successfully");
              }}
            />
            <AvatarFallback>
              <Icon
                iconName="AppsIcon"
                className="size-full fill-muted-foreground"
              />
            </AvatarFallback>
          </Avatar>
          <Text variant={TextVariant.labelSemiLarge}>
            {software.vendor.name || "-"}
          </Text>
        </HStack>
      </VStack>
      <SoftwareStatusSummary software={software} />
    </HStack>
  );
}
